import React from "react";
import { AxiosAuth } from "../core/axios";
import Notification from "rsuite/Notification";
import toaster from "rsuite/toaster";
import Loader from "rsuite/Loader";
import { ApiResponseContainer, PagedRequestParam } from "../models/api";
import { StorageAuth } from "../core/localStorage/StorageAuth";
import { IApiDownload } from "../core/apis";
import { DownloadUtils } from "../utils";

export const MessageDownloading = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification ref={ref} type="info" header="Info" closable duration={0}>
      <Loader size="md" content="Downloading" />
    </Notification>
  )
);

export const MessageDownloaded = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification
      ref={ref}
      type="success"
      header="Success"
      duration={3000}
      closable
    >
      Download Complete. Saving data...
    </Notification>
  )
);

export const MessageDownloadError = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification
      ref={ref}
      type="error"
      duration={3000}
      header="error"
      closable
    >
      Error downloading data.
    </Notification>
  )
);
// async function FetchAndBuildDataUrl(endpoint: string): Promise<string | null> {
//   let axiosConfig: AxiosRequestConfig = {
//     responseType: "arraybuffer",
//     headers: { Accept: "*/*" },
//   };
//   try {
//     const response = await AxiosAuth.get(endpoint, axiosConfig);
//     const URL = window.URL.createObjectURL(new Blob([response.data]));
//     return URL;
//   } catch (e) {
//     return null;
//   }
// }

async function DownloadExport(
  endpoint: string,
  fileName?: string
): Promise<void> {
  const startId = toaster.push(<MessageDownloading />, { placement: "topEnd" });
  try {
    const { data } = await AxiosAuth.get<ApiResponseContainer<IApiDownload>>(
      endpoint
    );
    toaster.remove(startId);
    setTimeout(async()=> {
      if (data?.isSuccess) {
        await DownloadUtils.downloadS3bucketFile(
          data?.data?.url!,
          data?.data?.fileName! || fileName!
        );
        const downloadedToastId = toaster.push(<MessageDownloaded />, {
          placement: "topEnd",
        });
        setTimeout(() => toaster.remove(downloadedToastId), 2000);
      } else {
        const errorToastId = toaster.push(<MessageDownloadError />, {
          placement: "topEnd",
        });
        setTimeout(() => toaster.remove(errorToastId), 3000);
      }
    },500);
  } catch (error) {
    toaster.remove(startId);
    setTimeout(()=> {
      const errorToastId = toaster.push(<MessageDownloadError />, {
        placement: "topEnd",
      });
      setTimeout(() => toaster.remove(errorToastId), 3000);
    },500);
  }
}

async function DownloadExportPaginated(
  endpoint: string,
  fileName: string,
  config?: PagedRequestParam & { [key: string]: any }
): Promise<void> {
  const { CompanyId } = StorageAuth;
  const endpointWithCompanyId = endpoint + "?CompanyID=" + CompanyId;
  if (!!config) {
    let params = Object.keys(config)
      .filter((key) => !!config[key] && !Array.isArray(config[key]))
      .map((key) => `${key[0].toUpperCase() + key.slice(1)}=${config[key]}`)
      .join("&");
    //const array  
    const arrayParams = Object.keys(config)
      .filter((key) => Array.isArray(config[key]))
      .map((key) => config[key].map((value:any)=> `${key[0].toUpperCase() + key.slice(1)}=${value}`).join("&")  )
      .join("&");

      params = [params,arrayParams].join("&");

    await DownloadExport(endpointWithCompanyId + "&" + params);
  } else {
    await DownloadExport(endpointWithCompanyId);
  }
}

export const LibExport = {
  DownloadExport,
  DownloadExportPaginated,
};
